import { render, staticRenderFns } from "./manageParcel优化版.vue?vue&type=template&id=e52e4960&scoped=true&"
import script from "./manageParcel优化版.vue?vue&type=script&lang=js&"
export * from "./manageParcel优化版.vue?vue&type=script&lang=js&"
import style0 from "./manageParcel优化版.vue?vue&type=style&index=0&id=e52e4960&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e52e4960",
  null
  
)

export default component.exports